// Static imports for Turbopack compatibility
// Dynamic imports with template literals are not supported in Turbopack
import commonDe from '@/translations/de/common.json';
import commonEn from '@/translations/en/common.json';
import commonNl from '@/translations/nl/common.json';

type ResourceMap = {
  [locale: string]: {
    [namespace: string]: typeof commonDe;
  };
};

export const resources: ResourceMap = {
  de: {
    common: commonDe,
  },
  en: {
    common: commonEn,
  },
  nl: {
    common: commonNl,
  },
};

export function getResource(
  language: string,
  namespace: string
): typeof commonDe | undefined {
  return resources[language]?.[namespace];
}
